import { Skeleton, SkeletonProps } from '@chakra-ui/react';
import { TODO } from '@habity/types';

interface ProfileSkeletonProps extends SkeletonProps { }

export const ProfileSkeleton = ({
  children,
  borderRadius = 'xl',
  ...props
}: ProfileSkeletonProps) => {
  return (
    <Skeleton
      borderRadius={borderRadius}
      startColor="blackAlpha.50"
      endColor="blackAlpha.100"
      isLoaded={true}
      {...props}
    >
      {children}
    </Skeleton>
  );
};

export const HideSkeleton = ({ children }: TODO) => {
  return <>{children}</>;
};
